// @flow

import React from 'react';
import { HeadingWithHTML, ResponsiveImage } from '@components/index';
import { LinkButton } from '@components/button/simple';
import { withLoading } from '@hocs/index';
import { PageNotFoundContainer, ButtonBar, Content } from './style';

type Props = {
  content: any,
};

const PageNotFound = ({
  content,
}: Props) => (
  <PageNotFoundContainer>
    <ResponsiveImage
      alt={content.image.title}
      src={content.image.source.lg}
      srcSet={content.image.source}
    />
    <Content>
      <HeadingWithHTML
        headingLevel="h1"
        title={content.main_title}
        html={content.main_text}
      />
      <ButtonBar>
        <LinkButton
          href={content.cta_button_1_url}
        >
          {content.cta_button_1_text}
        </LinkButton>
        <LinkButton
          href={content.cta_button_2_url}
          outline
          scheme="primary"
        >
          {content.cta_button_2_text}
        </LinkButton>
      </ButtonBar>
    </Content>
  </PageNotFoundContainer>
);

export default withLoading(PageNotFound);
